__webpack_require__.p = "https://tastermpoint-mfe-dashboard-cdt.maersk.io/mfe/dashboard/";